import { environmentHttpClient } from "client/Api/httpClient";
import { EventPagingInformationModel, EventPreviewModel } from "client/Api/Hub/Events/eventViewer";
import { HubItemTileResourceId } from "../../workspace";

export type EventInterests = {
	items?: true;
};

export type LiveInformationEventRequestModel = {
	resource: HubItemTileResourceId;
	interests: EventInterests;
};

export type LiveInformationEventResponseModelData = {
	items: LazyLoadPageResult<EventPreviewModel> | null;
};

export type LiveInformationEventResponseModel = {
	resource: HubItemTileResourceId;
	data: LiveInformationEventResponseModelData;
};

export type LoadMoreEventsRequest = {
	categoryIds: readonly number[] | null;
	lastRetrievedItem: EventPagingInformationModel;
};

export function list(
	eventCategoryWithInterests: LiveInformationEventRequestModel[]
): Promise<LiveInformationEventResponseModel[]> {
	return environmentHttpClient.post<LiveInformationEventResponseModel[]>(
		"Workspace/LiveInformation/Events",
		eventCategoryWithInterests
	);
}

export function listMore(
	model: LoadMoreEventsRequest,
	signal?: AbortSignal
): Promise<LazyLoadPageResult<EventPreviewModel>> {
	return environmentHttpClient.post<LazyLoadPageResult<EventPreviewModel>>(
		"Workspace/LiveInformation/Events/More",
		model,
		{ signal }
	);
}
